exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".landing-hero-image{margin:0 -40px}.landing-hero-image .background-image{height:100%;width:100%;background-size:cover}.landing-hero-image .small-background-image{height:100%;width:100%;margin-top:-10px;background-size:102%}.landing-hero-image .hero-content{width:100%;color:#fff;padding-bottom:10px}.landing-hero-image .landingPageTitle{color:#646464;font-size:25px;font-weight:600}.landing-hero-image .landingPageSubtitle{font-size:33px;color:#201f1f}.landing-hero-image .sub-nav-link-button{padding:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/ProductLanding/HeroImage.scss
// module id = 7644
// module chunks = 101